import { isArray, isBoolean, isNullOrUndefined, isNumber, isObject } from 'util';
import { PlessResponseHook } from '../../shared/http/pless-json-responder.service';

export class PlessResponseStringHook<T> implements PlessResponseHook<T> {

  private restrictLog: boolean = true;

  private outputLog(indent: number, str: string) {
    if (!this.restrictLog) {
      console.log(`${' ' .repeat(indent)} ${str}`);
    }
  }

  private processNumber(num: number, obj: object, key: string) {
    obj[key] = num?.toString();
  }

  private processBoolean(value: boolean, obj: object, key: string) {
    obj[key] = value?.toString();
  }

  private processObject(obj: object, indent: number) {

    Object.entries(obj).forEach(([key, value]) => {
      if (isArray(value)) {
        this.processArray(value as [], (indent + 1));
      }
      else {
        this.outputLog(indent, `${key} ${typeof value}`);

        if (isNullOrUndefined(value)) {
          obj[key] = "";
        }
        else if (isObject(value)) {
          this.processObject(value as object, (indent + 1));
        }
        else if (isNumber(value)) {
          this.processNumber(value as number, obj, key);
        }
        else if (isBoolean(value)) {
          this.processBoolean(value as boolean, obj, key);
        }
      }
    });
  }

  private processArray(values: [], indent: number) {

    values?.forEach((value, i) => {
      this.outputLog(indent, `[${i}]`);
      if (isObject(value)) {
        this.processObject(value, (indent + 1));
      }
    });
  }

  hook(url: string, obj: T): T {

    if (obj) {
      this.outputLog(0, `ResponseStringHook: ${url}`);
      if (isArray(obj)) {
        this.processArray(obj as [], 1);
      }
      else if (isObject(obj)) {
        this.processObject(obj as object, 1);
      }
    }
    return obj;
  }
}
